import { Container, Flex, Icon, Text } from "@chakra-ui/react";
import { Button, GoToMainButton } from "components";
import { Heading } from "elements";
import { CloseIcon } from "@chakra-ui/icons";
import { BsCreditCard } from "react-icons/bs";

const PaymentFailed = () => {
  return (
    <Container maxW='container.md' marginLeft={0}>
        <GoToMainButton />
        <Flex marginTop={5} flexDirection='column' marginLeft={0} marginBottom={5} paddingLeft={0}>
            <Flex align='center' position='relative'>
                <Icon as={BsCreditCard} w={20} h={20} marginRight={8} />
                <Flex position='absolute' top={1} left={14} padding={3} backgroundColor='#F24866'  borderRadius='50px'>
                    <CloseIcon color="white"/>
                </Flex>
                <Flex flexDirection='column'>
                    <Heading title="Payment failed" color="#F24866" fontSize="42px" fontWeight={700}/>
                    <Text color="#6F6F6F" fontWeight={400} fontSize="12px">We are sorry, this transaction was either declined by the card issuer or our payment system</Text>
                </Flex>
            </Flex>
            <Flex flexDirection='row' justifyContent='space-between'marginTop={20} marginBottom={20}>
                <Flex flexDirection='column' marginRight='50px'>
                    <Text color="#6F6F6F" fontWeight={500} fontSize="16px">Amount</Text>
                    <Text color="#1F1E1E" fontSize="20px" fontWeight={500}>€ 1.595</Text>
                </Flex>
                <Flex flexDirection='column' marginRight='50px'>
                    <Text color="#6F6F6F" fontWeight={500} fontSize="16px">Payment ID </Text>
                    <Text color="#1F1E1E" fontSize="20px" fontWeight={500}>1045830575</Text>
                </Flex>
                <Flex flexDirection='column' marginRight='50px'>
                    <Text color="#6F6F6F" fontWeight={500} fontSize="16px">Payment Type</Text>
                    <Text color="#1F1E1E" fontSize="20px" fontWeight={500}>Debit card</Text>
                </Flex>
                <Flex flexDirection='column' marginRight='50px'>
                    <Text color="#6F6F6F" fontWeight={500} fontSize="16px">Transaction Time</Text>
                    <Text color="#1F1E1E" fontSize="20px" fontWeight={500}>Unsuccessful</Text>
                </Flex>
            </Flex>
                <Button size="lg"label="Retry My Order" onClick={function (): void {
                    throw new Error("Function not implemented.");
                } } colorScheme="blue" />
        </Flex>
        
    </Container>
  );
};

export { PaymentFailed };
